module.exports = "https://assets.niwcorp.com/_next/static/images/bannerShape-bfc28e9424e27f5036aab2460aabcbcc.png";